import Game from '../game/Game'
import { newGame, loadGoal } from './game'
export { newGame, NEW_GAME } from './game'
export const SET_MAKE_CHALLENGE_ERROR = 'SET_MAKE_CHALLENGE_ERROR'
export const CHANGE_NEW_CHALLENGE_ID = 'CHANGE_NEW_CHALLENGE_ID'
export const CHANGE_NEW_CHALLENGE_CONFIG = 'CHANGE_NEW_CHALLENGE_CONFIG'
export const CHANGE_NEW_CHALLENGE_ROBOT = 'CHANGE_NEW_CHALLENGE_ROBOT'
export const CHALLENGE_SUBMITTED = 'CHALLENGE_SUBMITTED'

export function fetchChallengeId(){
  return dispatch => {
    dispatch(newGame())
    let goals_to_add = [1, 2, 3, 4]
    goals_to_add.forEach(() => Game.newGoal())
    dispatch(selectGoal(0))
    return fetch('/challenge/lastofallconfig')
      .then(response => response.json())
      .then(json => dispatch(changeNewChallengeId(json === null ? 1 : json.challengeId + 1 )))
  }
}

export function makeChallenge(challengeId, config){
  return (dispatch, getState) => {
    dispatch(setMakeChallengeError(null)) // clear error
    fetch('/challenge/config', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(getGameDefinition(getState))
    }).then((response) => response.json())
      .then((json) => {
        if (json.success) {
          dispatch(challengeSubmitted())
          localStorage.removeItem('currentChallenge')
        }
        else {
          dispatch(setMakeChallengeError(json.error))
        }
    })
  }
}

export function setMakeChallengeError(error) {
  return {
    type: SET_MAKE_CHALLENGE_ERROR,
    error: error
  }
}

export function changeNewChallengeId(challengeId) {
  return {
    type: CHANGE_NEW_CHALLENGE_ID,
    challengeId: challengeId
  }
}

export function changeNewChallengeConfig(config) {
  return (dispatch, getState) => {
    dispatch({
      type: CHANGE_NEW_CHALLENGE_CONFIG,
      config
    })
    localStorage.removeItem('currentChallenge')
    dispatch(newGame(getGameDefinition(getState)))
  }
}

export function selectGoal(goal_num) {
  Game.logInstance.selectRecord(goal_num)
  return loadGoal(Game.logInstance.getCurrentRecord())
}

export function changeGoal(goal_obj) {
  Game.logInstance.selectRecord(goal_obj.goal_num)
  const data = {
    goal: goal_obj.goal,
    goalColor: goal_obj.color
  }
  Game.logInstance.modifyRecord(data)
  return selectGoal(goal_obj.goal_num)
}

export function changeNewChallengeRobot(robot_obj) {
  return (dispatch, getState) => {
    dispatch(Object.assign({
      type: CHANGE_NEW_CHALLENGE_ROBOT,
    }, robot_obj))
    // call Game.newGame but don't dispatch, because that breaks this
    newGame(getGameDefinition(getState))
  }
}

export function challengeSubmitted() {
  return {
    type: CHALLENGE_SUBMITTED
  }
}

function getGameDefinition(getState) {
  const state = getState()
  return {
    config: state.newChallenge.config,
    goals: serializeRecords(state.log.records),
    robots: serializeRobots(state.robot),
    challengeId: state.newChallenge.challengeId
  }
}

function serializeRecords(records) {
  return records.map(record => [record.goal[0], record.goal[1], record.goalColor])
}

function serializeRobots(robots) {
  return Object.keys(robots).map(color => [robots[color].location[0], robots[color].location[1], color])
}


// WEBPACK FOOTER //
// ./actions/ChallengeMaker.js